import { HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';
import React, { useState } from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../components/TableContent';
import { VariableIncomeDetail } from '../../../../../store/transactionFlow/types';
import { IDynamicProductSearchItem } from '../_dynamic';

import { tableHead } from './constants';

const ProductSearchItem = ({
  item,
  product,
  onSelectClient,
}: IDynamicProductSearchItem<VariableIncomeDetail>) => {
  const [isHovered, setIsHovered] = useState(false);
  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent
      direction="column"
      space={0}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}>
      <Box
        position={'absolute'}
        top={0}
        left={0}
        bottom={0}
        w={'4px'}
        backgroundColor={Color[product.color]}
        borderTopLeftRadius={'full'}
        borderBottomLeftRadius={'full'}
      />
      <HStack w="full" alignItems="center">
        <TableContentItemColumn flex={getFlex(0)}>
          <TableContentItemText>{item.requestDate}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(1)}>
          <TableContentItemText>{item.movementType}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(2)}>
          <Pressable
            onHoverIn={() => setIsHovered(true)}
            onHoverOut={() => setIsHovered(false)}
            onPress={() => onSelectClient(item.clientDocument)}>
            {isHovered ? (
              <TableContentItemText color="brand.tertiary.principal">
                {item.clientName}
              </TableContentItemText>
            ) : (
              <TableContentItemText>{item.clientName}</TableContentItemText>
            )}
          </Pressable>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(3)}>
          <TableContentItemText>{item.productName}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(4)}>
          <TableContentItemText>{item.maturityDate}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(5)}>
          <TableContentItemText>{item.movementValue}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(6)}>
          <TableContentItemText>{item.status}</TableContentItemText>
        </TableContentItemColumn>
      </HStack>
    </TableContent>
  );
};

export default React.memo(ProductSearchItem);
